const CustomFonts = [
    {
        name: "Chunk Type"
    },
    {
        name: "DaisyWheel"
    },
    {
        name: "F25 Executive"
    }
];

export { CustomFonts };
